// extracted by mini-css-extract-plugin
export default {"messageList":"ChatContent_messageList__zBk7l","messageItem":"ChatContent_messageItem__91Zj4"};